import { lazyNamed } from 'src/utils/lazyNamed';

export const SupportCenter = {
  Tickets: lazyNamed(() => import('./pages/Tickets'), 'Tickets'),
  TicketForm: lazyNamed(() => import('./pages/TicketForm'), 'TicketForm'),
  TicketOverview: lazyNamed(() => import('./pages/TicketOverview'), 'TicketOverview'),
};
